import { is } from "../../../../date-fns/locale/is.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    is
  }
};